import Icon from '@/common/components/Icon';
import Table from '@/common/components/Table';
import { useMemo, useState } from 'react';
import {
	Section,
	SectionHeader,
	TableWrapper,
} from '../../SerpMonitoringReport.styles';
import { getRows } from './helpers/getRows';
import { Colors } from '@/common/colors/colors';

const HEADERS = [
	'',
	'Date',
	'Keyword',
	'Position',
	'Type',
	'Title',
	'Category',
	'Points',
	'Link',
	'Alert',
	'Score',
	'Grade',
];

const SerpMonitoringMainTable = ({
	mainResults = [],
	dayResults = [],
	onCategoryChange,
}) => {
	const [isOpen, setIsOpen] = useState(true);
	const [expandedIds, setExpandedIds] = useState({});

	const toggleResult = (resultId) => {
		setExpandedIds((current) => ({
			...current,
			[resultId]: !current[resultId],
		}));
	};

	const rows = useMemo(
		() =>
			getRows({
				mainResults,
				dayResults,
				expandedIds,
				onToggleResult: toggleResult,
				onCategoryChange,
			}),
		[mainResults, dayResults, expandedIds, onCategoryChange],
	);

	return (
		<Section>
			<SectionHeader type='button' onClick={() => setIsOpen((current) => !current)}>
				Results
				<Icon name={isOpen ? 'chevron-down' : 'chevron-up'} color={Colors.darkBlue} />
			</SectionHeader>
			{isOpen && (
				<TableWrapper>
					<Table className='styled-table' headers={HEADERS} raws={rows} />
				</TableWrapper>
			)}
		</Section>
	);
};

export default SerpMonitoringMainTable;
